import { CATEGORY_ATTR, SRC_ATTR, type BlockingContext } from "./context";

/**
 * Dev-only. The one gap the runtime guards cannot close is a tracker `<script src>` sitting
 * in the initial HTML: the preload scanner may fetch it before any JavaScript runs, so
 * execution is stopped but the request may already have left.
 *
 * Those are exactly the items the MutationObserver caught rather than a setter, so the
 * report reads them out of the blocked-item log — by the time this runs the `src`
 * attribute is long gone from the DOM, which is why querying for `script[src]` would find
 * nothing at all.
 */
export function runAuditor(context: BlockingContext): void {
  const findings = context.items
    .all()
    .filter((item) => item.kind === "script" && item.source === "observer");

  if (findings.length === 0) return;

  console.groupCollapsed(
    `%c[consentkit]%c ${findings.length} tracker script(s) hardcoded in the HTML — ` +
      "execution was stopped, but the request may already have gone out. Tag them to close the gap.",
    "color:#c8401f;font-weight:600",
    "color:inherit",
  );
  for (const item of findings) {
    console.info(
      `${item.url}\n  replace with:\n` +
        `  <script type="text/plain" ${CATEGORY_ATTR}="${item.category}" ${SRC_ATTR}="${item.url}"></script>`,
    );
  }
  console.groupEnd();
}
